module.exports = __webpack_public_path__ + "img/84600.bbf6525f.jpg";